module.exports = __webpack_public_path__ + "static/media/backbone.25c6159d.jpeg";